/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'
import { AccessAlarm, CheckCircleOutlineOutlined, HighlightOff, StarsRounded } from '@material-ui/icons'
import { dinamicTablesStyles } from "./styles"

const BossesTable = ({ info, filterPartners }) => {
  const [filteredArray, setFilteredArray] = useState(info)
  const [boss, setBoss] = useState('todas')
  const [quizzState, setQuizzState] = useState('todas')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedBtn, setSelectedBtn] = useState('todas')
  const [count, setCount] = useState(info)
  const classes = dinamicTablesStyles()

  const filterArray = (type, key) => {
    const bossSelected = type === 'boss' ? key : boss
    const quizzesSelected = type === 'quizz' ? key : quizzState
    const actionsSelected = type === 'action' ? key : selectedBtn
    const newArrayBosses = bossSelected !== 'todas' ? info.filter(el => (el.jefe === bossSelected)) : info
    const newArrayQuizzes = quizzesSelected !== 'todas' ? newArrayBosses.filter(el => el[quizzesSelected] > 0) : newArrayBosses
    const newArrayActions = actionsSelected !== 'todas' ? newArrayQuizzes.filter(el => el[actionsSelected] > 0) : newArrayQuizzes
    setFilteredArray(newArrayActions)
    setCount(newArrayActions)
    if (type === 'action') {
      setSelectedBtn(key)
    }
    setPage(0)
  };
  const handleChange = (e, type) => {
    type === 'boss' ? setBoss(e.target.value) : setQuizzState(e.target.value)
    type === 'boss' && filterPartners(e.target.value)
    filterArray(type, e.target.value)
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const updateValues = () => {
    setFilteredArray(info)
    setBoss('todas')
    setQuizzState('todas')
    setSelectedBtn('todas')
    setCount(info)
  }
  useEffect(() => {
    updateValues()
  }, [info])

  return (
    <Box className={classes.container} >
      <h3 className={classes.title}>Jefe</h3>
      <Box className={classes.containerQuizzesFilters}>
        <FormControl>
          <InputLabel id='select-partner' style={{color: '#5A5A5A'}}>Jefe</InputLabel>
          <Select
            labelId='select-partner'
            value={boss}
            className={classes.select}
            onChange={e => handleChange(e,'boss')}
          >
            <MenuItem value='todas'>Todos los jefes</MenuItem>
            {info.map((partner) => (
              <MenuItem value={partner.jefe} key={partner.idJefe}>{partner.jefe}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel id='select-quizz' style={{color: '#5A5A5A'}}>Estado de la encuesta</InputLabel>
          <Select
            labelId='select-quizz'
            value={quizzState}
            className={classes.select}
            onChange={e => handleChange(e, 'quizz')}
          >
            <MenuItem value='todas'>Todas las encuestas</MenuItem>
            <MenuItem value='encuestasEnviadas'>Enviadas</MenuItem>
            <MenuItem value='encuestasConsolidadas'>Consolidadas</MenuItem>
            <MenuItem value='encuestasPendientes'>Pendientes</MenuItem>
            <MenuItem value='encuestasSinEnviar'>Sin enviar</MenuItem>
          </Select>
        </FormControl>
        <Box>
          <Button
            className={selectedBtn === 'todas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','todas')}
          >
            Todas las acciones
          </Button>
          <Button
            className={selectedBtn === 'totalAcciones' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action', 'totalAcciones')}
            startIcon={<StarsRounded style={{ color: '#F5CD26' }} />}
          >
            Total
          </Button>
          <Button
            className={selectedBtn === 'totalCompletadas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalCompletadas')}
            startIcon={<CheckCircleOutlineOutlined style={{ color: '#65BA0F' }} />}
          >
            Completas
          </Button>
          <Button
            className={selectedBtn === 'totalPendientes' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalPendientes')}
            startIcon={<AccessAlarm style={{ color: '#2699FB' }} />}
          >
            Pendientes
          </Button>
          <Button
            className={selectedBtn === 'totalVencidas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalVencidas')}
            startIcon={<HighlightOff style={{ color: '#BA330F' }} />}
          >
            Vencidas
          </Button>
        </Box>
      </Box>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Gerente</TableCell>
              <TableCell>Jefe</TableCell>
              <TableCell>Encuestas enviadas</TableCell>
              <TableCell>Encuestas conciliadas</TableCell>
              <TableCell>Encuestas pendientes</TableCell>
              <TableCell>Encuestas sin enviar</TableCell>
              <TableCell>Total acciones</TableCell>
              <TableCell>Acciones completas</TableCell>
              <TableCell>Acciones pendientes</TableCell>
              <TableCell>Acciones vencidas</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {filteredArray?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(partner => (
              <TableRow key={partner.idJefe}>
                <TableCell>{partner.gerente}</TableCell>
                <TableCell style={{color: '#2699FB'}}>{partner.jefe}</TableCell>
                <TableCell >{partner.encuestasEnviadas}</TableCell>
                <TableCell>{partner.encuestasConsolidadas}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.encuestasPendientes}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.encuestasSinEnviar}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.totalAcciones}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.totalCompletadas}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.totalPendientes}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.totalVencidas}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default BossesTable